export const ADD_NEW_COMMENT = 'ADD_NEW_COMMENT';
export const ADD_NEW_REPLY = 'ADD_NEW_REPLY';
export const COMMENT_BOX_CANCELLED = 'COMMENT_BOX_CANCELLED';
export const COMMENT_BOX_OPENED = 'COMMENT_BOX_OPENED';
